// The export endpoint returns a PDF, so its RTK mutation is declared with a blob
// responseHandler and a transformResponse that pulls the filename out of
// content-disposition (apiSlice.js). That means the caller has to do something with
// result.data — awaiting the mutation alone renders the PDF server-side, records the
// audit bundle row, and then drops it on the floor. History did exactly that, so
// "View PDF →" looked like a dead button.
//
// Shared so there is one place that knows the contract, rather than Export owning the
// only correct copy.

/** Triggers a browser download for a completed export. */
function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

/**
 * Runs the export mutation and downloads the result.
 * Returns null on success, or a human-readable message on failure.
 *
 * The error body is a blob too (the responseHandler applies to error responses as
 * well), so it has to be read back as text before the message can be pulled out.
 */
export async function downloadHSExport(exportPdf, params) {
  const result = await exportPdf(params);

  if (result.error) {
    try {
      const text = await result.error.data.text();
      return JSON.parse(text).error_message || "Export failed — please try again.";
    } catch {
      // non-JSON error body (a proxy error page, say) — keep the generic message
      return "Export failed — please try again.";
    }
  }

  saveBlob(result.data.blob, result.data.filename);
  return null;
}
